/* eslint-disable */
import lodash from 'lodash'

/**
 * Mixin des images
 *
 */
var Mixin = function (options) {

    this.getBaseSquare = function () {
        if (this.square && lodash.isString(this.square)) {
            return this.square;
        } else if (this._links && this._links.square) {
            return this._links.square;
        } else if (this.square) {
            return this.square;
        }

        return false;
    };

    this.getSquareUrl = function () {
        var base = this.getBaseSquare();
        if (!base || !base.normal || !base.normal.href) {
            // dans les images de base, il y a aussi la carrée. On va la
            // récupérer s'il n'y a pas d'image spéciale carrée
            if (this._links && this._links.images && this._links.images.squaresmall) {
                return this._links.images.squaresmall.href || '';
            }
            return '';
        }
        return base.normal.href;
    };

    this.getOriginalSquareUrl = function () {
        var base = this.getBaseSquare();
        if (!base || !base.raw || !base.raw.href) {
            return '';
        }
        return base.raw.href;
    };

    this.getThumbSquareUrl = function () {
        var base = this.getBaseSquare();

        if (lodash.isString(base)) {
            return base;
        }

        if (!base || !base.thumb || !base.thumb.href) {
            return ''; // config.images[this.getType()].square['default'];
        }
        if (!base.thumb.href) {
            // dans les images de base, il y a aussi la carrée. On va la
            // récupérer s'il n'y a pas d'image spéciale carrée
            if (this._links && this._links.images && this._links.images.squaremini) {
                return this._links.images.squaremini.href || '';
            }
        }
        return base.thumb.href;
    };

    this.initSquare = function () {
        if (!this._links) {
            this._links = {};
        }
        if (!this._links.square) {
            this._links.square = {
                normal: {},
                raw: {},
                thumb: {}
            };
        }
    };

    this.setRawSquareUrl = function (url) {
        if (url.charAt(0) !== '/') {
            url = '/' + url;
        }
        this.initSquare();
        this._links.square.raw.href = url;
        return this;
    };

    this.setThumbSquareUrl = function (url) {
        if (url.charAt(0) !== '/') {
            url = '/' + url;
        }
        this.initSquare();
        this._links.square.thumb.href = url;
        return this;
    };

    this.setSquareUrl = function (url) {
        if (url.charAt(0) !== '/') {
            url = '/' + url;
        }
        this.initSquare();
        this._links.square.normal.href = url;
        return this;
    };

    return this;
};

export default Mixin;
